const FALLBACK = 'Validation failed.';

const parseDetail = (raw: string): string | null => {
  try {
    const detail = (JSON.parse(raw) as { detail?: unknown }).detail;
    return typeof detail === 'string' ? detail : null;
  } catch {
    return null;
  }
};

export const extractDataBuilderRowLimitErrorMessage = (
  error: Error | null
): string => {
  const message = error?.message ?? '';
  return parseDetail(message) || message || FALLBACK;
};
